const buildVersion = '1.0.0.0'
const obj = {
  getDeliverySiteInformation: {
    data: {
      customerInformation: {
        title: 'Kundinformation',
        downloadLink: {
          label: 'Ladda ner Min rapport (PDF)',
          url: '#',
          target: '_blank'
        },
        information: [
          {
            label: 'Kund',
            value: 'Namn Namnsson'
          },
          {
            label: 'Boendeform',
            value: 'Lägenhet'
          },
          {
            label: 'Mätarplacering',
            value: 'I bostad'
          },
          {
            label: 'Mätartavla',
            value: 'PA1'
          }
        ]
      },
      deliveryInformation: {
        title: 'Anläggningsinformation',
        information: [
          {
            label: 'Anläggnings-ID',
            value: '7359 9102 1070 99171'
          },
          {
            label: 'Anläggningsadress',
            value: 'Elgatan 102, 115 30 Stockholm'
          },
          {
            label: 'Anläggningstyp',
            value: 'Konsumtionsanläggning'
          },
          {
            label: 'Mätarnummer',
            value: '55055 1428 4570 8484'
          },
          {
            label: 'Anläggningsstatus',
            value: 'Aktiv'
          },
          {
            label: 'Startdatum',
            value: '1951-01-01'
          }
        ]
      },
      chargingBasedInformation: {
        title: 'Debiteringsgrundande uppgifter',
        information: [
          {
            label: 'Elnätsabonnemang',
            value: 'FD_IN_MIKRO_EJ_MOMS'
          },
          {
            label: 'Mätmetod',
            value: 'Månadsavläsning'
          },
          {
            label: 'Antal faser',
            value: '3-Fas'
          },
          {
            label: 'Mätarsäkring',
            value: '25 Ampere'
          },
          {
            label: 'Beräknad årsförbrukning (kWh)',
            value: '1 269 kWh'
          }
        ]
      },
      onlineInformation: {
        title: 'Nätinformation',
        information: [
          {
            label: 'Servisnummer',
            value: 'C7219'
          },
          {
            label: 'Nätområde',
            value: 'STH Stockholm'
          }
        ]
      },
      contractPartner: {
        title: 'Avtalspartner',
        information: [
          {
            label: 'Nätleverantör',
            value: '14900 Ellevio'
          },
          {
            label: 'Elhandelsleverantör',
            value: 'Fortum Markets AB'
          }
        ]
      }
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getOptInOutInformation: {
    data: {
      communicationTypeList: [
        {
          heading: 'Nyheter och erbjudanden',
          preamble: 'Ex elprisstöd, projektarbeten, om elnätet och din förbrukning, priskommunikation m.m.',
          channels: [
            {
              id: 1,
              name: 'Newsletter',
              active: true,
              type: 'Email'
            }
          ]
        },
        {
          heading: 'Kundinformation',
          preamble: 'Ex elprisstöd, projektarbeten, om elnätet och din förbrukning, priskommunikation m.m.',
          channels: [
            {
              id: 4,
              name: 'Customer information',
              active: true,
              type: 'SMS'
            },
            {
              id: 5,
              name: 'Customer information',
              active: false,
              type: 'Email'
            }
          ]
        },
        {
          heading: 'Avtalsinformation',
          preamble: 'Vi informerar dig på sms och epost när något påverkar leveransen av el till er som ex. byte av elmätare eller villkorsändringar.',
          channels: null
        }
      ]
    },
    meta: {
      version: '1.0.0.0'
    },
    messages: [],
    errors: []
  },
  getOptInOutInformationxxx: {
    data: {
      communicationTypeList: [
        {
          heading: 'Nyheter och erbjudanden',
          preamble: 'Ex elprisstöd, projektarbeten, om elnätet och din förbrukning, priskommunikation m.m.',
          channels: [
            {
              id: 1,
              name: 'Newsletter',
              active: true,
              type: 'Email'
            }
          ]
        },
        {
          heading: 'Kundinformation',
          preamble: 'Ex elprisstöd, projektarbeten, om elnätet och din förbrukning, priskommunikation m.m.',
          channels: [
            {
              id: 4,
              name: 'Customer information',
              active: true,
              type: 'SMS'
            },
            {
              id: 5,
              name: 'Customer information',
              active: true,
              type: 'Email'
            }
          ]
        },
        {
          heading: 'Avtalsinformation',
          preamble: 'Vi informerar dig på sms och epost när något påverkar leveransen av el till er som ex. byte av elmätare eller villkorsändringar.',
          channels: []
        }
      ]
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  putOptInOutInformation: {
    data: { success: true },
    meta: { version: buildVersion },
    messages: ['Tack för att du uppdaterat våra kontaktvägar till dig!'],
    errors: []
  },
  getPriceCalculationData_real_data: {
    data: {
      networkFeeVariable: '0,00 öre/kWh',
      networkFeeVariableLow: '0,00 öre/kWh',
      networkFeeVariableHigh: '0,00 öre/kWh',
      networkFeeHighLowExists: false,
      networkFeeFixed: ' kr/mån',
      networkFeeFixedValue: null,
      networkFeeEstimatedElectricityCost: '430 kr/mån',
      energyTax: '45,00 öre/kWh',
      energyTaxEstimatedElectricityCost: '589 kr/mån',
      energyTaxEstimatedElectricityCostValue: 589,
      energyTaxEstimatedElectricityCostUnFormatted: null,
      estimatedTotalCost: '589 kr/mån',
      estimatedTotalCostUnFormatted: '589',
      highLoad: ' öre/kWh',
      lowLoad: ' öre/kWh',
      powerTariffCostText: '2,81 kW x 52 kr/kW = 146,12 kr',
      calculatedAvgMaxPower: '2,81 kW',
      calculatedAvgMaxPowerMissing: true,
      effectFee: '52 kr/kW, mån',
      estimatedEffectFee: '146,12 kr/mån',
      estimatedEffectFeeValue: 146
    },
    meta: {
      version: '1.0.0.0'
    },
    messages: [],
    errors: []
  },

  getSearchAddresses: {
    data: [
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '602',
        letter: 'C'
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '604',
        letter: 'B'
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '606',
        letter: ''
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '608',
        letter: ''
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '610',
        letter: ''
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '612',
        letter: ''
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '616',
        letter: 'A'
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '616',
        letter: 'B'
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '616',
        letter: 'C'
      },
      {
        street: 'Vallhalla',
        postcode: '826 66',
        locality: 'Marmaverken',
        street_number: '618',
        letter: ''
      }
    ],
    meta: {
      version: '1.0.0.0'
    },
    messages: [],
    errors: []
  },

  getPriceCalculationData: {
    data: {
      networkFeeVariable: '49,50 öre/kWh',
      networkFeeVariableLow: '11,00 öre/kWh',
      networkFeeVariableHigh: '62,50 öre/kWh',
      networkFeeHighLowExists: true,
      networkFeeFixed: '99,50 kr/mån',
      networkFeeFixedValue: 99.5,
      networkFeeEstimatedElectricityCost: '130 kr/mån',
      energyTax: '49,51 öre/kWh',
      energyTaxEstimatedElectricityCost: '78 kr/mån',
      energyTaxEstimatedElectricityCostValue: 78,
      estimatedTotalCostUnFormatted: '2 124',
      estimatedTotalCost: '177 kr/mån',
      highLoad: '-4,30 öre/kWh',
      lowLoad: '-3,60 öre/kWh',
      powerTariffCostText: '17,8 kW x 52 kr/kW = 93,43 kr',
      calculatedAvgMaxPower: '4,8 kW',
      calculatedAvgMaxPowerMissing: false,
      effectFee: '3,2 öre/kW',
      estimatedEffectFee: '127 kr/mån',
      estimatedEffectFeeValue: 127
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },

  //Uppdaterat svarsobjekt
  getConsumptionDataMock1: {
    data: {
      direction: 'Consumption',
      isPowerTariff: true,
      isConsumptionSite: true,
      hasReactiveEnergy: true,
      hasMeteringValues: true,
      currentYearConsumption: {
        unit: 'kWh',
        value: '1 527',
        periodDescription: '1 januari 2022 - 20 januari 2022'
      },
      estimatedYearlyConsumption: {
        unit: 'kWh',
        value: '7 011',
        periodDescription: '2022'
      },
      currentYearProduction: null,
      estimatedYearlyProduction: null,
      currentYearReactive: {
        unit: 'kVA',
        value: '107',
        periodDescription: '2022'
      },
      estimatedYearlyReactive: null
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getConsumptionDataMock1NoPowerTariff: {
    data: {
      direction: 'Consumption',
      isPowerTariff: false,
      isConsumptionSite: true,
      hasReactiveEnergy: true,
      hasMeteringValues: true,
      currentYearConsumption: {
        unit: 'kWh',
        value: '1 627',
        periodDescription: '1 januari 2022 - 20 januari 2022'
      },
      estimatedYearlyConsumption: {
        unit: 'kWh',
        value: '7 011',
        periodDescription: '2022'
      },
      currentYearProduction: null,
      estimatedYearlyProduction: null,
      currentYearReactive: {
        unit: 'kVA',
        value: '107',
        periodDescription: '2022'
      },
      estimatedYearlyReactive: null
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },

  //Uppdaterat svarsobjekt
  getConsumptionDataMock2: {
    data: {
      direction: 'Production',
      isPowerTariff: false,
      isConsumptionSite: false,
      hasReactiveEnergy: false,
      hasMeteringValues: false,
      currentYearConsumption: null,
      estimatedYearlyConsumption: null,
      currentYearProduction: {
        unit: 'kWh',
        value: 4003,
        periodDescription: '2022'
      },
      estimatedYearlyProduction: null,
      currentYearReactive: null,
      estimatedYearlyReactive: null
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },

  //Uppdaterat svarsobjekt
  getConsumptionDataCombined: {
    data: {
      consumptionSummary: {
        direction: 'Consumption',
        isConsumptionSite: true,
        hasReactiveEnergy: true,
        hasMeteringValues: false,
        currentYearConsumption: {
          unit: 'kWh',
          value: '4 485 283',
          periodDescription: '1 januari 2022 - 19 april 2022'
        },
        currentYearProduction: null,
        estimatedYearlyConsumption: {
          unit: 'kWh',
          value: '0',
          periodDescription: '2022'
        },
        estimatedYearlyProduction: null,
        currentYearReactive: {
          unit: 'kVA',
          value: '708 207',
          periodDescription: '1 januari 2022 - 19 april 2022'
        },
        estimatedYearlyReactive: {
          unit: 'kVA',
          value: '2 377 065',
          periodDescription: '2022'
        }
      },
      productionSummary: {
        direction: 'Production',
        isConsumptionSite: false,
        hasReactiveEnergy: true,
        hasMeteringValues: false,
        currentYearConsumption: null,
        currentYearProduction: {
          unit: 'kWh',
          value: '91',
          periodDescription: '1 januari 2022 - 19 april 2022'
        },
        estimatedYearlyConsumption: null,
        estimatedYearlyProduction: null,
        currentYearReactive: {
          unit: 'kVA',
          value: '18 714',
          periodDescription: '1 januari 2022 - 19 april 2022'
        },
        estimatedYearlyReactive: null
      }
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getInvoiceData: {
    data: {
      items: [
        [
          '2021-09-28',
          '909 kr',
          '6100 2575 2943 0',
          {
            type: 'boolean',
            value: false,
            text: 'Obetald'
          },
          {
            type: 'link',
            text: 'Se fakturan',
            href: '#',
            target: '_blank'
          }
        ],
        [
          '2021-09-28',
          '909 kr',
          '6100 2575 2943 0',
          {
            type: 'boolean',
            value: true,
            text: 'Betald'
          },
          {
            type: 'link',
            text: 'Se fakturan',
            href: '#',
            target: '_blank'
          }
        ],
        [
          '2021-09-28',
          '909 kr',
          '6100 2575 2943 0',
          {
            type: 'boolean',
            value: true,
            text: 'Betald'
          },
          {
            type: 'link',
            text: 'Se fakturan',
            href: '#',
            target: '_blank'
          }
        ],
        [
          '2021-09-28',
          '909 kr',
          '6100 2575 2943 0',
          {
            type: 'boolean',
            value: true,
            text: 'Betald'
          },
          {
            type: 'link',
            text: 'Se fakturan',
            href: '#',
            target: '_blank'
          }
        ],
        [
          '2021-09-28',
          '909 kr',
          '6100 2575 2943 0',
          {
            type: 'boolean',
            value: true,
            text: 'Betald'
          },
          {
            type: 'link',
            text: 'Se fakturan',
            href: '#',
            target: '_blank'
          }
        ]
      ]
    },
    meta: {
      totalItemsCount: 123,
      version: buildVersion
    },
    messages: ['Inga fakturor att visa', 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In venenatis varius ante, nec lobortis mauris vehicula id. Pellentesque ut arcu sceler.'],
    errors: []
  },
  getOverviewInvoiceData: {
    data: {
      items: [
        {
          text: '2021-09-28',
          value: true,
          statusText: 'Betald',
          href: '#',
          target: '_blank'
        },
        {
          text: '2021-09-28',
          value: false,
          statusText: 'Obetald',
          href: '#',
          target: '_blank'
        },
        {
          text: '2021-09-28',
          value: true,
          statusText: 'Anstånd utan ränta',
          href: '#',
          target: '_blank'
        }
      ]
    },
    meta: {},
    messages: [],
    errors: []
  },
  getOverviewPowerOutageData: {
    data: {
      items: [
        {
          text: 'Shockvägen 23B',
          value: false,
          statusText: 'Inaktiv',
          href: '#',
          target: '_blank'
        },
        {
          text: 'Sommarhusvägen 8B',
          value: true,
          statusText: 'Aktiv',
          href: '#',
          target: '_blank'
        },
        {
          text: 'Shockvägen 23B',
          value: false,
          statusText: 'Inaktiv',
          href: '#',
          target: '_blank'
        },
        {
          text: 'Shockvägen 23B',
          value: false,
          statusText: 'Inaktiv',
          href: '#',
          target: '_blank'
        },
        {
          text: 'Shockvägen 23B',
          value: false,
          statusText: 'Inaktiv',
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-power-outage-notifications--example&args=&viewMode=story&deliverysiteid=735999000000000008',
          target: '_blank'
        },
        {
          text: 'Shockvägen 1',
          value: false,
          statusText: 'Inaktiv',
          href: '#',
          target: '_blank'
        }
      ]
    },
    meta: {},
    messages: [],
    errors: []
  },
  getAccountSettingsEmailData: {
    data: {
      username: 'ellen.strom@stromming.se'
    },
    meta: {
      version: buildVersion
    },
    messages: [],
    errors: []
  },
  getMeterReadingsData: {
    data: {
      items: Array.from({ length: 5 }, (_, index) => [
        '2022-01-' + (index + 1).toString().padStart(2, '0'),
        {
          type: 'boolean',
          value: index % 2 === 0 ? true : false
        },
        ['Låglast', 'Höglast', 'Normallast', 'Reaktiv'].sort(() => 0.5 - Math.random())[0],
        index + 1 + '' + Math.floor(Math.random() * (999 - 100 + 1)) + 100,
        Math.floor(Math.random() * (9999 - 1000 + 1)) + 1000
      ])
    },
    meta: {
      totalItemsCount: 52,
      version: buildVersion
    },
    messages: [],
    errors: []
  },
  getInvoiceSettingsData: {
    data: {
      streetName: 'Götgatan',
      streetNumber: '81',
      apartmentNumber: 1234,
      postcode: '11130',
      postOffice: 'Strömsta',
      careOf: 'Ellen'
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getDeliverySites1: {
    data: [
      {
        id: '735999000000000001',
        idFormated: '(735999) 000 000 000 001',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Elchocken 23B',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000002',
        idFormated: '(735999) 000 000 000 002',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Elchocken 23B',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000003',
        idFormated: '(735999) 000 000 000 003',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Sommarhusvägen 3, Testar lite längre adress 234',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000004',
        idFormated: '(735999) 000 000 000 004',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Sommarhusvägen 3',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000005',
        idFormated: '(735999) 000 000 000 005',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Fjällgatan 15',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000006',
        idFormated: '(735999) 000 000 000 006',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Fjällgatan 15',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000007',
        idFormated: '(735999) 000 000 000 007',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Sankt Fannysplan 112',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000008',
        idFormated: '(735999) 000 000 000 008',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Sankt Fannysplan 112',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000009',
        idFormated: '(735999) 000 000 000 009',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Mormorsgränd 76',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000010',
        idFormated: '(735999) 000 000 000 010',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Farfarssvängen 1',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      }
    ],
    meta: { version: buildVersion, count: 10 },
    messages: [],
    errors: []
  },
  getDeliverySites2: {
    data: [
      {
        id: '735999000000000055',
        idFormated: '(735999) 000 000 000 055',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Elchocken 11B',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      }
    ],
    meta: { version: buildVersion, count: 1 },
    messages: [],
    errors: []
  },
  getDeliverySites3: {
    data: [
      {
        id: '735999000000000006',
        idFormated: '(735999) 000 000 000 006',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Fjällgatan 15',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000007',
        idFormated: '(735999) 000 000 000 007',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Sankt Fannysplan 112',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000008',
        idFormated: '(735999) 000 000 000 008',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Sankt Fannysplan 112',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000009',
        idFormated: '(735999) 000 000 000 009',
        type: 'Konsumtionsanläggning',
        isConsumptionSite: true,
        address: 'Mormorsgränd 76',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      },
      {
        id: '735999000000000010',
        idFormated: '(735999) 000 000 000 010',
        type: 'Produktionsanläggning',
        isConsumptionSite: false,
        address: 'Farfarssvängen 1',
        measuringMethod: 'Timavläsning',
        hasHourlyMeasuringMethod: true
      }
    ],
    meta: { version: buildVersion, count: 10 },
    messages: ['xxxx'],
    errors: []
  },
  getPowerOutageNotificationsData: {
    data: {
      emailList: [
        {
          id: 1,
          value: 'demo@demosson.se',
          operation: null
        },
        {
          id: 2,
          value: 'test@testsson.nu',
          operation: null
        }
      ],
      phoneList: [
        {
          id: 3,
          value: '+46735999999',
          valueFormatted: '+46 73 599 99 99',
          operation: null
        },
        {
          id: 4,
          value: '+46735888888',
          valueFormatted: '+46 73 588 88 88',
          operation: null
        }
      ]
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getActiveSubscriptions: {
    data: {
      active: 8
    },
    meta: {
      totalItemsCount: 359,
      version: buildVersion
    },
    messages: [],
    errors: []
  },
  getRealTimeMeasurementData: {
    data: {
      active: false,
      available: true
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  postAppInsightsData: {
    success: true
  },
  postPowerOutageNotifications: {
    data: {
      emailList: [
        {
          id: 1,
          value: 'demo@demosson.se',
          operation: null
        }
      ],
      phoneList: [
        {
          id: 3,
          value: '+46735999999',
          valueFormatted: '+46 73 511 11 11',
          operation: null
        },
        {
          id: 4,
          value: '+46735888888',
          valueFormatted: '+46 73 522 22 22',
          operation: null
        }
      ]
    },
    meta: { version: buildVersion },
    messages: ['Dina prenumerationsinställningar har sparats'],
    errors: []
  },
  addAccount: {
    data: [
      {
        isMainAccount: true,
        accountName: 'Bollnäs kommun',
        customerNumber: '123456'
      },
      {
        isMainAccount: false,
        accountName: 'Bennys cyklar',
        customerNumber: '234234'
      },
      {
        isMainAccount: false,
        accountName: 'Tomtens renar',
        customerNumber: '3456756'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 1',
        customerNumber: '12345646456'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 7',
        customerNumber: '678'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 88',
        customerNumber: '6789'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 99',
        customerNumber: '67333'
      }
    ],
    meta: { version: buildVersion },
    messages: ['Kontot har lagts till!'],
    errors: []
  },
  removeAccount: {
    data: [
      {
        isMainAccount: true,
        accountName: 'Bollnäs kommun',
        customerNumber: '123456'
      },
      {
        isMainAccount: false,
        accountName: 'Bennys cyklar',
        customerNumber: '234234'
      },
      {
        isMainAccount: false,
        accountName: 'Tomtens renar',
        customerNumber: '3456756'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 1',
        customerNumber: '12345646456'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 7',
        customerNumber: '678'
      }
    ],
    meta: { version: buildVersion },
    messages: ['Kontot har tagits bort!'],
    errors: []
  },
  deleteUserAccount: {
    data: {
      redirecturl: '/iframe.html?id=mypages-pages-my-details--example&viewMode=story&deleted=true'
    },
    meta: { version: buildVersion },
    messages: ['Något gick fel!'],
    errors: []
  },
  postInvoiceSettingsData: {
    data: {
      streetName: 'Götgatanx',
      streetNumber: '811',
      apartmentNumber: 1111,
      postcode: '11111',
      postOffice: 'Strömstax',
      careOf: 'Ellenx'
    },
    meta: { version: buildVersion },
    messages: ['Din adress har sparats'],
    errors: []
  },
  postAccountSettingsEmail: {
    data: {
      username: 'ellen.strom@stromming.com'
    },
    meta: { version: buildVersion },
    messages: ['Din e-postadress har sparats'],
    errors: []
  },
  postAccountSettingsPassword: {
    data: {},
    meta: { version: buildVersion },
    messages: ['Ditt lösenord har sparats'],
    errors: []
  },
  postRealTimeMeasurement: {
    data: {
      active: true,
      available: true
    },
    meta: { version: buildVersion },
    messages: ['Lokalt gränssnitt för realtidsmätning är nu aktiverat/avaktiverat.', 'Det kan ta lite tid innan dina ändringar syns i gränssnittet.'],
    errors: []
  },
  getCustomerDetails: {
    data: {
      name: 'Ellen Ström',
      streetName: 'Elchocken',
      streetNumber: '102',
      apartmentNumber: 1203,
      postcode: '111 30',
      postOffice: 'Stockholm',
      careOf: 'Kilo Watt'
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getContactDetails: {
    data: {
      email: 'el.strom@stromming.se',
      mobile: '',
      mobileFormatted: '',
      // mobile: '+46731234567',
      // mobileFormatted: '+46 73 123 45 67',
      telephone: '+468312323',
      telephoneFormatted: '+46 8 31 23 23'
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  postContactDetails: {
    data: {
      email: 'el.strom@stromming.se',
      mobile: '+46731234567',
      mobileFormatted: '+46 99 999 99 99',
      telephone: '+468312323',
      telephoneFormatted: '+46 8 31 23 23'
    },
    meta: { version: buildVersion },
    messages: ['Dina kontaktuppgifter har sparats'],
    errors: []
  },
  getCustomers: {
    data: [
      {
        isMainAccount: true,
        accountName: 'Bostadsrättsföreningen Bollnäs kommun',
        customerNumber: '123456'
      },
      {
        isMainAccount: false,
        accountName: 'Bennys cyklarxx',
        customerNumber: '234234'
      },
      {
        isMainAccount: false,
        accountName: 'Tomtens renar',
        customerNumber: '3456756'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 1',
        customerNumber: '12345646456'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 7',
        customerNumber: '678'
      },
      {
        isMainAccount: false,
        accountName: 'Brf Asplången 10',
        customerNumber: '26867'
      }
    ],
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getDeliverySitesData: {
    data: {
      exportLinks: [
        {
          label: 'Visa summerad data',
          url: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&groupid=1234567891011111',
          target: '_self'
        },
        {
          label: 'Exportera anläggningslistan till Excel',
          url: '#',
          target: '_self'
        }
      ],
      items: Array.from({ length: 10 }, (_, index) => [
        {
          type: 'id',
          value: '123456789101111' + index
        },
        {
          type: 'link',
          text: 'Gatunamn, 123 45 Stockholm ' + (index + 1),
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        },
        {
          type: 'link',
          text: '12345 678910 1111' + index,
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        },
        {
          type: 'link',
          text: 'Mätmetod',
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        }
      ])
    },
    meta: {
      totalItemsCount: 360,
      version: buildVersion
    },
    messages: ['Anläggningar - rubrik', 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In venenatis varius ante, nec lobortis mauris vehicula id. Pellentesque ut arcu sceler.'],
    errors: []
  },
  // getGroupsData: {
  //   data: Array.from({ length: 10 }, (_, index) => ({
  //     id: `${index + 1}`,
  //     name: 'Gruppnamn ' + (index + 1),
  //     deliverySiteIds: Array.from({ length: 10 }, (_, innerIndex) => '73599900000000000' + (innerIndex + 1))
  //   })),
  //   meta: { version: buildVersion },
  //   messages: [],
  //   errors: []
  // },
  getGroupsData: {
    data: [
      { id: 1, name: 'Blandad grupp', deliverySiteIds: ['735999000000000001', '735999000000000002', '735999000000000003', '735999000000000004', '735999000000000005', '735999000000000006', '735999000000000007'] },
      { id: 2, name: 'Konsumption', deliverySiteIds: ['735999000000000001', '735999000000000003', '735999000000000005'] },
      { id: 3, name: 'Produktion', deliverySiteIds: ['735999000000000002', '735999000000000004', '735999000000000006'] }
    ],
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getGroupData: {
    data: {
      exportLinks: [
        {
          label: 'Visa summerad data',
          url: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&groupid=1234567891011111',
          target: '_self'
        },
        {
          label: 'Exportera anläggningslistan till Excel',
          url: '#',
          target: '_self'
        },
        {
          label: 'Ändra gruppnamn',
          eventName: 'changeGroupName'
        },
        {
          label: 'Lägg till anläggning i grupp',
          eventName: 'addDeliverySiteToGroup'
        },
        {
          label: 'Radera grupp',
          eventName: 'deleteGroup'
        }
      ],
      items: Array.from({ length: 5 }, (_, index) => [
        {
          type: 'id',
          value: '123456789101111' + index
        },
        {
          type: 'selectable',
          value: false
        },
        {
          type: 'link',
          text: 'Gatunamn, 123 45 Stockholm ' + (index + 1),
          href: '#',
          target: '_self'
        },
        {
          type: 'link',
          text: '12345 678910 1111' + index,
          href: '#',
          target: '_self'
        },
        {
          type: 'link',
          text: 'Mätmetod',
          href: '#',
          target: '_self'
        },
        {
          type: 'context',
          value: [
            {
              label: 'Lägg till i grupp',
              eventName: 'addToGroup',
              params: {
                items: ['123456789101111' + index]
              }
            },
            {
              label: 'Skapa grupp',
              eventName: 'createGroup',
              params: {
                items: ['123456789101111' + index]
              }
            },
            {
              label: 'Ta bort ur grupp',
              eventName: 'removeFromGroup',
              params: {
                items: ['123456789101111' + index]
              }
            }
          ]
        }
      ])
    },
    meta: {
      totalItemsCount: 17,
      version: buildVersion
    },
    messages: ['Anläggningar - rubrik', 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In venenatis varius ante, nec lobortis mauris vehicula id. Pellentesque ut arcu sceler.'],
    errors: []
  },
  getDeliverySitesDataGroups: {
    data: {
      exportLinks: [
        {
          label: 'Visa summerad data',
          url: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&groupid=1234567891011111',
          target: '_self'
        },
        {
          label: 'Exportera anläggningslistan till Excel',
          url: '#',
          target: '_self'
        }
        // {
        //   label: 'Ändra gruppnamn',
        //   eventName: 'changeGroupName',
        //   params: {
        //     groupId: 'grupp-id'
        //   }
        // },
        // {
        //   label: 'Lägg till anläggning i grupp',
        //   eventName: 'addDeliverySiteToGroup'
        // },
        // {
        //   label: 'Radera grupp',
        //   eventName: 'deleteGroup',
        //   params: {
        //     groupId: 'grupp-id'
        //   }
        // }
      ],
      items: Array.from({ length: 10 }, (_, index) => [
        {
          type: 'id',
          value: '123456789101111' + index
        },
        {
          type: 'selectable',
          value: false
        },
        {
          type: 'link',
          text: 'Gatunamn, 123 45 Stockholm ' + (index + 1),
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        },
        {
          type: 'link',
          text: '12345 678910 1111' + index,
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        },
        {
          type: 'link',
          text: 'Mätmetod',
          href: 'http://localhost:6007/iframe.html?id=mypages-pages-electricity-consumption--energikonto-groups&args=&viewMode=story&deliverysiteid=735999000000000007',
          target: '_self'
        },
        {
          type: 'context',
          value: [
            {
              label: 'Lägg till i grupp',
              eventName: 'addToGroup',
              params: {
                items: ['123456789101111' + index]
              }
            },
            {
              label: 'Skapa grupp',
              eventName: 'createGroup',
              params: {
                items: ['123456789101111' + index]
              }
            }
          ]
        }
      ])
    },
    meta: {
      totalItemsCount: 360,
      version: buildVersion
    },
    messages: ['Anläggningar - rubrik', 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In venenatis varius ante, nec lobortis mauris vehicula id. Pellentesque ut arcu sceler.'],
    errors: []
  },
  postCreateGroup: {
    meta: { version: buildVersion },
    data: Array.from({ length: 5 }, (_, index) => ({
      id: `${index + 1}`,
      name: 'Gruppnamn ' + (index + 1),
      deliverySiteIds: Array.from({ length: 10 }, (_, innerIndex) => '123456789101111' + innerIndex)
    })),
    messages: ['Gruppen har skapats'],
    errors: []
  },
  postHandleGroups: {
    meta: { version: buildVersion },
    data: Array.from({ length: 4 }, (_, index) => ({
      id: `${index + 1}`,
      name: 'Gruppnamn ' + (index + 1),
      deliverySiteIds: Array.from({ length: 10 }, (_, innerIndex) => '123456789101111' + innerIndex)
    })),
    messages: ['Gruppen har uppdaterats'],
    errors: []
  },
  getPowerOutageNotificationTableData: {
    data: {
      items: Array.from({ length: 10 }, (_, index) => [
        {
          type: 'id',
          value: 'radens-id-' + (index + 1)
        },
        {
          type: 'selectable',
          value: false
        },
        {
          type: 'boolean',
          value: index % 2 !== 0,
          text: index % 2 !== 0 ? 'Aktiv' : 'Inaktiv',
          noIcon: true
        },
        `Demogatan ${index + 1} (735999) 000 000 000 00${index + 1}`,
        {
          type: 'array',
          content: 'phoneList',
          valueFormatted: index % 2 !== 0 ? ['+46 70 123 45 60', '+46 70 123 45 61', '+46 70 123 45 62'] : [],
          value: index % 2 !== 0 ? ['+46701234560', '+46701234561', '+46701234562'] : []
        },
        {
          type: 'array',
          content: 'emailList',
          value: index % 2 !== 0 ? ['demo@demosson.se', 'test@testsson.com'] : []
        }
      ])
    },
    meta: {
      totalItemsCount: 98,
      version: buildVersion
    },
    messages: [],
    errors: []
  },
  getCreditPaymentsTableData: {
    data: {
      items: Array.from({ length: 5 }, (_, index) => [
        {
          type: 'id',
          value: 'radens-id-' + (index + 1)
        },
        {
          type: 'selectable',
          value: false,
          disabled: index > 2,
          params: {
            price: 150 * (index + 1)
          }
        },
        {
          type: 'date',
          value: `2023-${(12 - index).toString().padStart(2, '0')}-31`,
          valueFormatted: `Textformat av: 2023-${(12 - index).toString().padStart(2, '0')}-31`
        },
        `${150 * (index + 1)} kr`,
        {
          type: 'boolean',
          value: index > 2,
          text: index > 2 ? 'Utbetald' : 'Krediteras',
          noIcon: true
        },
        `Elprisstöd`
      ])
    },
    meta: {
      totalItemsCount: 98,
      version: buildVersion
    },
    messages: [],
    errors: []
  },
  getCurrentSession: {
    data: {
      expires: 1119,
      heading: 'Är du där?',
      message: 'På grund av inaktivitet kommer du loggas ut om {timeleft} minuter.<br />Vill du fortsätta vara inloggad?',
      buttonText: 'Fortsätt vara inloggad'
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  postExtendCurrentSession: {
    data: {},
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getCustomerServiceAdminImpersonate: {
    data: {
      customerName: 'Christina Lundqvist',
      isCorporate: false,
      isActive: true
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  postCustomerServiceAdminImpersonate: {
    data: {
      redirectUrl: 'https://www.ellevio.se/privat/mina-sidor/oversikt'
    },
    meta: { version: buildVersion },
    messages: [],
    errors: []
  },
  getEffectPriceCalculationData: {
    data: {
      networkFeeVariable: '0,00 öre/kWh',
      networkFeeVariableLow: '0,00 öre/kWh',
      networkFeeVariableHigh: '0,00 öre/kWh',
      networkFeeHighLowExists: false,
      networkFeeFixed: ' kr/mån',
      networkFeeEstimatedElectricityCost: '0 kr/mån',
      energyTax: '45,00 öre/kWh',
      energyTaxEstimatedElectricityCost: '495 kr/mån',
      energyTaxEstimatedElectricityCostUnFormatted: null,
      estimatedTotalCost: '495 kr/mån',
      estimatedTotalCostUnFormatted: '495',
      highLoad: ' öre/kWh',
      lowLoad: ' öre/kWh',
      powerTariffCostText: '17,8 kW x 52 kr/kW = 93,43 kr',
      calculatedAvgMaxPower: '12,6 kW',
      calculatedAvgMaxPowerMissing: false,
      // powerTariffCostText: '-- kW x -- kr/kW = -- kr',
      // calculatedAvgMaxPower: '-- kW',
      periodHasActivePowerTariff: true
    },
    meta: { version: '1.0.0.0' },
    messages: [],
    errors: []
  },
  getPossiblePayoutsData: {
    data: [
      {
        openItemId: 1111111,
        amount: 225.0,
        transactionDate: '31 januari 2023'
      },
      {
        openItemId: 2222,
        amount: 240.43,
        transactionDate: '28 februari 2023'
      },
      {
        openItemId: 3333333333333,
        amount: 1085.3,
        transactionDate: '30 mars 2023'
      }
    ],
    meta: { version: '1.0.0.0' },
    messages: [],
    errors: []
  },
  postPossiblePayouts: {
    data: [
      {
        openItemId: 2222,
        amount: 240.43,
        transactionDate: '28 februari 2023'
      }
    ],
    meta: { version: '1.0.0.0' },
    messages: ['2 utbetalningar har registrerats!'],
    errors: []
  },
  getBankAccountDetailsData: {
    data: {
      // bankName: '',
      // bankAccountFormatted: '',
      // bankAccountOrig: ''
      bankName: 'Handelsbanken',
      bankAccountDisplay: '123-4, 123 45 67',
      bankAccountFormatted: '123-4, 123 45 67',
      bankAccountOrig: '12341234567'
    },
    meta: { version: '1.0.0.0' },
    messages: [],
    errors: []
  },
  postBankAccountDetails: {
    data: {
      bankName: 'Handelsbanken',
      bankAccountDisplay: '123-4, 123 45 67',
      bankAccountFormatted: '123-4, 123 45 67',
      bankAccountOrig: '12341234567'
    },
    meta: { version: '1.0.0.0' },
    messages: ['Något gick fel när bankuppgifterna skulle sparas.'],
    errors: []
  },
  getBankAccountValidation: {
    data: {
      isValid: true
    },
    meta: { version: '1.0.0.0' },
    messages: ['Felmeddelande vid felaktigt kontonumer.'],
    errors: []
  }
}

obj.postPowerOutageNotificationsBatch = {
  data: obj.getPowerOutageNotificationTableData.data,
  meta: obj.getPowerOutageNotificationTableData.meta,
  messages: ['Dina prenumerationsinställningar (BATCH) har sparats'],
  errors: []
}

let env = {}
try {
  env = import.meta.env
  if (typeof env !== 'object') env = {}
} catch (_) {
  env = {}
}

export default env.STORYBOOK === 'true'
  ? {
      randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      },
      ...obj
    }
  : {
      randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min
      }
    }
